export default "__VITE_ASSET__DzhmgOFg__"